
import { css } from 'lit';
export default css`
.here-to-help {margin-bottom: 3rem;display: flex;flex-direction: column;justify-content: space-between;border-bottom-width: 1px;--tw-border-opacity: 1;border-color: rgba(164, 167, 171, var(--tw-border-opacity));padding-bottom: 0.25rem
}@media (min-width: 1200px) {.here-to-help {display: grid
  }.here-to-help {grid-template-columns: repeat(2, minmax(0, 1fr))
  }
}.here-to-help__left_column {display: flex
}.here-to-help__left_column {flex-direction: column
}@media (min-width: 768px) {.here-to-help__left_column {display: grid
  }
}@media (min-width: 768px) {.here-to-help__left_column {grid-template-columns: repeat(2, minmax(0, 1fr))
  }
}@media (min-width: 1200px) {.here-to-help__left_column {display: flex
  }
}@media (min-width: 1200px) {.here-to-help__left_column {flex-direction: column
  }
}.here-to-help__left_column-row {padding-bottom: 2.5rem
}.here-to-help__right_column {display: grid
}.here-to-help__right_column {grid-template-columns: repeat(1, minmax(0, 1fr))
}@media (min-width: 768px) {.here-to-help__right_column {grid-template-columns: repeat(2, minmax(0, 1fr))
  }
}.here-to-help__right_column-row {padding-bottom: 2.5rem
}.here-to-help .here_to_help__heading {padding-bottom: 0.5rem
}@media (min-width: 640px) {.here-to-help .here_to_help__heading {padding-bottom: 1.25rem
  }
}
`;